<template>
  <section class="section">
    <div class="level">
      <div class="level-left">
        <h1 class="title">Lista de Grupos de Usuarios</h1>
      </div>
      <div class="level-right">
        <button class="button is-info is-primary" @click="openModalAddGroup">
          Agregar Grupo
        </button>
      </div>
    </div>

    <base-table
      class="is-bordered is-striped is-narrow is-fullwidth is-hoverable"
      :columns="groupColumns"
      :data="userGroupsList"
      :loading="loading"
    />

    <!-- Modal inline -->
    <div class="modal" :class="{ 'is-active': modalAddGroup }">
      <div class="modal-background" @click="closeModalAddGroup"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Agregar Grupo</p>
          <button class="delete" aria-label="close" @click="closeModalAddGroup"></button>
        </header>
        <section class="modal-card-body">
          <div class="field">
            <label class="label">Nombre del Grupo</label>
            <div class="control">
              <input class="input" type="text" v-model="newGroup.name" placeholder="Ej: GRUPO_REFERIDO" />
            </div>
          </div>

          <!-- <div class="field">
            <label class="checkbox">
              <input type="checkbox" v-model="newGroup.active" />
              Activo
            </label>
          </div> -->
        </section>
        <footer class="modal-card-foot">
          <button class="button is-info" :disabled="loadingAdd || !newGroup.name" @click="handleCreateGroup">
            Guardar
          </button>
          <button class="button" @click="closeModalAddGroup">Cancelar</button>
        </footer>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'TablaGruposUsuarios',
  components: {
    BaseTable: () => import('@/components/Table')
  },
  data () {
    return {
      userGroupsList: [],
      loading: false,
      loadingAdd: false,
      modalAddGroup: false,
      newGroup: {
        name: '',
        active: true
      },
      groupColumns: [
        {
          id: 'id',
          header: 'ID',
          type: 'link',
          link: true,
          route: (row) => `/usuarios?page=1&filter=${row.id}`
        },
        {
          id: 'name',
          header: 'Nombre del Grupo',
          type: 'link',
          link: true,
          route: (row) => `/usuarios?page=1&filter=${row.id}`
        },
        // {
        //   id: 'active',
        //   header: 'Activo',
        //   accessor: row => (row.active ? 'Sí' : 'No')
        // },
        { id: 'totalusers', header: 'Total de Usuarios' }
      ]
    }
  },
  methods: {
    ...mapActions(['getUsergroups', 'createUsergroups']),
    openModalAddGroup () {
      this.modalAddGroup = true
    },
    closeModalAddGroup () {
      this.modalAddGroup = false
      this.newGroup = { name: '', active: true }
    },
    handleCreateGroup () {
      this.loadingAdd = true
      this.createUsergroups(this.newGroup)
        .then(() => this.getUsergroups())
        .then(groups => {
          this.userGroupsList = groups
          this.loadingAdd = false
          this.modalAddGroup = false
          this.newGroup = { name: '', active: true }
        })
        .catch(() => {
          this.loadingAdd = false
        })
    }
  },
  mounted () {
    this.loading = true
    this.getUsergroups()
      .then(groups => {
        this.userGroupsList = groups
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>

<style scoped>
.section {
  width: 100%;
  padding: 20px;
}
.title {
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 24px;
}
.level {
  align-items: center;
  margin-bottom: 20px;
}
</style>
